import TextField from '@mui/material/TextField';
import { Grid, InputAdornment } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { aiHighlightSx, aiIconSx, customFieldInputSx } from '../styles/CommonStyles';

const styles = {
    customFieldsBox: {
        backgroundColor: 'var(--spectre-surface)',
        mt: 1
    }
}

export default function CustomFieldTextBox(props: any) {
    const { index, customField, updateCustomFieldSubmitValues, customFieldSubmitValues, isAiPopulated } = props

    const value = customFieldSubmitValues['CustomFields']['Field'][index]['Value'];
    const isAiHighlighted = !!isAiPopulated;

    return (
        <Grid item md={11} xs={11} sx={styles.customFieldsBox}>
            <TextField 
                label={customField.name}
                variant="outlined" 
                size="small" 
                fullWidth 
                required={customField.required}
                value={value} 
                onChange={(element) => { 
                    updateCustomFieldSubmitValues(index, element.target.value) 
                }}
                InputProps={isAiHighlighted ? {
                    endAdornment: (
                        <InputAdornment position="end">
                            <AutoAwesomeIcon sx={aiIconSx} fontSize="small" />
                        </InputAdornment>
                    )
                } : {}}
                sx={{ ...customFieldInputSx, ...(isAiHighlighted ? aiHighlightSx : {}) }}
            />
        </Grid>
    );
}